import {AirportPickupFeeInfo as AirportPickupFeeContent} from '@/customComponents/BookRideSteps/Components/airportPickupFeeInfo.jsx'

// Same content as the booking flow's airport-fee popup (carSelection /
// selectedCarDetailsLatest), which already carries the plugin's copy — this used to be
// a "Coming soon" placeholder. Reused rather than duplicated, the way
// PayAfterDropoffPopup pulls in PayAfterDropoffContent, so the wording can't drift
// between the two flows. The Modal supplies the side/bottom padding; only the gap under
// the header is set here.
export default function AirportPickupFeeInfo() {
    return (
        <div className="pt-2 text-(--text-secondary)">
            <AirportPickupFeeContent/>
        </div>
    )
}
